export const placeholderList = [
  {
    id: 1,
    image: 'loading.jpg'
  },
  {
    id: 2,
    image: 'loading.jpg'
  },
  {
    id: 3,
    image: 'loading.jpg'
  }
];
